import clsx from "clsx";

const SOURCES = {
  horizontal: {
    light: "/brand/horizontal-light.svg",
    dark: "/brand/horizontal-dark.svg",
  },
  icon: {
    light: "/brand/icon-light.svg",
    dark: "/brand/icon-dark.svg",
  },
  micro: {
    light: "/brand/micro-mark.svg",
    dark: "/brand/micro-mark.svg",
  },
};

const BrandLogo = ({
  variant = "horizontal",
  surface = "light",
  decorative = false,
  className,
  alt = "Sporthouse",
  ...props
}) => (
  <img
    src={SOURCES[variant][surface]}
    alt={decorative ? "" : alt}
    aria-hidden={decorative ? "true" : undefined}
    className={clsx("block h-auto object-contain", className)}
    {...props}
  />
);

export default BrandLogo;
